module.exports = __webpack_public_path__ + "media/images/admin/icons/move-835cfd943edfecb6064f6d6b0447f703.svg";